module.exports = __webpack_public_path__ + "img/Under 18 Icon - white.898db6cd.svg";